// Assuming getTextColorHelper and other dependencies are ES6 modules
import getTextColorHelper from './getTextColorHelper';

/**
 * Set header theme
 */
async function setHeaderThemeFromImage() {
    const carouselFirstImage = document.querySelector('.product-detail .swiper-wrapper .product-image');
    let theme = 'default'; // Default theme if no image is found or an error occurs

    if (carouselFirstImage) {
        const imgElement = carouselFirstImage.querySelector('img');
        if (imgElement) {
            try {
                theme = await getTextColorHelper.getTextColorThemeByImage(imgElement);
            } catch (error) {
                theme = 'default';
            }
        }
    }

    const navbar = document.getElementById('headerComponent').querySelector('.ds-navbar');
    navbar.classList.remove('navbar-theme-dark', 'navbar-theme-light');
    navbar.classList.add('navbar-' + theme);
}

/**
 * Setting up event listeners
 */
function setupEventListeners() {
    $('body').on('imageCarousel:loaded', () => {
        setHeaderThemeFromImage();
    });
}

export default {
    init: function () {
        setupEventListeners();
    }
};
